(function() {
    let form = document.getElementById('pagen-size');
    let select = form.querySelector('select');
    select.onchange = function() {
        form.submit();
    };

    let styleSelects = require('../styled-select/styled-select');
    styleSelects.styleSelects($(select));
})();



// WEBPACK FOOTER //
// ./blocks/reviews_about/reviews_about.js